import React,{useEffect,useRef,useState} from 'react';
import './SlideBCoin.css';

var FEATURES=[
  {icon:'◆',label:'Verified Source',sub:'Solidity 0.8.21 — open-source contract'},
  {icon:'⚡',label:'BEP-20 Standard',sub:'Native to BNB Smart Chain (BSC)'},
  {icon:'∑',label:'18 Decimals',sub:'Precision token with full divisibility'},
  {icon:'⚙',label:'Mint · Burn · Pause',sub:'Owner-controlled supply governance'},
];

var STATS=[
  {label:'TOKEN NAME',value:'BEST COIN'},
  {label:'SYMBOL',value:'BCOIN'},
  {label:'NETWORK',value:'BNB Smart Chain'},
  {label:'STANDARD',value:'BEP-20'},
  {label:'DECIMALS',value:'18'},
  {label:'PRICE',value:'$0.01 (₹1)'},
];

var CONTRACT='0xD38c8c437b7837Cf50F8E654D4880cf810ECDd22';

export default function SlideBCoin({slideNumber,totalSlides,pdfMode}){
  var canvasRef=useRef(null);
  var [phase,setPhase]=useState(pdfMode?6:0);
  var [copied,setCopied]=useState(false);
  var [activeStat,setActiveStat]=useState(-1);

  useEffect(function(){
    var c=canvasRef.current;if(!c)return;var ctx=c.getContext('2d');
    var W=c.width=window.innerWidth,H=c.height=window.innerHeight,run=true;
    function onR(){W=c.width=window.innerWidth;H=c.height=window.innerHeight;}
    window.addEventListener('resize',onR);
    var fp=[];for(var i=0;i<55;i++)fp.push({x:Math.random()*W,y:Math.random()*H,vx:(Math.random()-0.5)*0.12,vy:-0.04-Math.random()*0.16,sz:Math.random()*1.6+0.4,al:Math.random()*0.13+0.04,hue:[45,0,30,340][Math.floor(Math.random()*4)]});
    var coins=[];for(var i=0;i<10;i++)coins.push({x:Math.random()*W,y:Math.random()*H,vx:(Math.random()-0.5)*0.05,vy:-0.03-Math.random()*0.06,sz:18+Math.random()*22,rot:Math.random()*6.28,rv:(Math.random()-0.5)*0.008,al:0.025+Math.random()*0.025});
    var lts=[];function spLt(){var sx=Math.random()*W,sy=Math.random()<0.5?0:H;var a=Math.atan2(H/2-sy+(Math.random()-0.5)*H*0.4,W/2-sx+(Math.random()-0.5)*W*0.4);var len=Math.min(W,H)*0.16;var pts=[{x:sx,y:sy}];var px=sx,py=sy;for(var ii=0;ii<6;ii++){px+=Math.cos(a)*(len/6)+(Math.random()-0.5)*22;py+=Math.sin(a)*(len/6)+(Math.random()-0.5)*22;pts.push({x:px,y:py});}lts.push({pts:pts,life:0,mx:14,c:Math.random()>0.5?'251,191,36':'165,42,58',w:0.7});}
    var T=0;function draw(){if(!run)return;T++;ctx.clearRect(0,0,W,H);
      ctx.strokeStyle='rgba(251,191,36,0.005)';ctx.lineWidth=0.3;
      for(var x=0;x<W;x+=58){ctx.beginPath();ctx.moveTo(x,0);ctx.lineTo(x,H);ctx.stroke();}
      for(var y=0;y<H;y+=58){ctx.beginPath();ctx.moveTo(0,y);ctx.lineTo(W,y);ctx.stroke();}
      // Floating gold coins
      for(var i=0;i<coins.length;i++){var co=coins[i];co.x+=co.vx;co.y+=co.vy;co.rot+=co.rv;if(co.y<-50){co.y=H+50;co.x=Math.random()*W;}if(co.x<-40)co.x=W+40;if(co.x>W+40)co.x=-40;
        ctx.save();ctx.translate(co.x,co.y);
        var sq=Math.cos(co.rot);
        ctx.scale(Math.max(0.2,Math.abs(sq)),1);
        var rg=ctx.createRadialGradient(0,0,0,0,0,co.sz);
        rg.addColorStop(0,'rgba(253,230,138,'+(co.al*1.8)+')');
        rg.addColorStop(0.6,'rgba(251,191,36,'+(co.al*1.2)+')');
        rg.addColorStop(1,'rgba(184,134,11,'+(co.al*0.6)+')');
        ctx.fillStyle=rg;ctx.beginPath();ctx.arc(0,0,co.sz,0,6.28);ctx.fill();
        ctx.strokeStyle='rgba(165,42,58,'+(co.al*1.4)+')';ctx.lineWidth=1;ctx.stroke();
        ctx.fillStyle='rgba(165,42,58,'+(co.al*2)+')';ctx.font='bold '+Math.round(co.sz*0.75)+'px Orbitron';ctx.textAlign='center';ctx.textBaseline='middle';ctx.fillText('B',0,0);
        ctx.restore();
      }
      for(var i=0;i<fp.length;i++){var p=fp[i];p.x+=p.vx;p.y+=p.vy;if(p.y<-20){p.y=H+20;p.x=Math.random()*W;}if(p.x<-20)p.x=W+20;if(p.x>W+20)p.x=-20;var fl=p.al+Math.sin(T*0.01+p.x)*0.03;ctx.beginPath();ctx.arc(p.x,p.y,p.sz,0,6.28);ctx.fillStyle='hsla('+p.hue+',85%,60%,'+Math.max(0,fl)+')';ctx.fill();}
      if(T%45<2)spLt();
      for(var i=lts.length-1;i>=0;i--){var l=lts[i];l.life++;if(l.life>l.mx){lts.splice(i,1);continue;}var a2=1-l.life/l.mx;ctx.beginPath();ctx.moveTo(l.pts[0].x,l.pts[0].y);for(var j=1;j<l.pts.length;j++)ctx.lineTo(l.pts[j].x+(Math.random()-0.5)*3,l.pts[j].y+(Math.random()-0.5)*3);ctx.strokeStyle='rgba('+l.c+','+(a2*0.14)+')';ctx.lineWidth=l.w;ctx.stroke();}
      requestAnimationFrame(draw);}
    draw();return function(){run=false;window.removeEventListener('resize',onR);};
  },[]);

  useEffect(function(){
    if(pdfMode)return;
    var t=[
      setTimeout(function(){setPhase(1);},200),
      setTimeout(function(){setPhase(2);},500),
      setTimeout(function(){setPhase(3);},950),
      setTimeout(function(){setPhase(4);},1500),
      setTimeout(function(){setPhase(5);},2100),
      setTimeout(function(){setPhase(6);},2700),
    ];
    return function(){t.forEach(clearTimeout);};
  },[]);

  useEffect(function(){
    if(phase<6)return;var running=true;var i=0;
    function cycle(){if(!running)return;setActiveStat(i);i=(i+1)%STATS.length;setTimeout(function(){if(running)cycle();},1800);}
    cycle();return function(){running=false;};
  },[phase]);

  function copyContract(){
    if(navigator.clipboard){navigator.clipboard.writeText(CONTRACT);}
    setCopied(true);setTimeout(function(){setCopied(false);},1800);
  }

  var addrShort=CONTRACT.slice(0,8)+'…'+CONTRACT.slice(-6);

  return React.createElement('div',{className:'sbc'},
    React.createElement('canvas',{ref:canvasRef,className:'sbc__canvas'}),
    React.createElement('div',{className:'sbc__flash'+(phase>=1?' fire':'')}),
    ['tl','tr','bl','br'].map(function(pos){
      return React.createElement('div',{key:pos,className:'sbc__corner sbc__corner--'+pos+(phase>=6?' show':'')},
        React.createElement('svg',{viewBox:'0 0 100 100',fill:'none'},
          React.createElement('path',{d:'M0 45V2H2V0H45',stroke:pos.includes('b')?'rgba(251,191,36,0.6)':'rgba(165,42,58,0.6)',strokeWidth:'1'}),
          React.createElement('circle',{cx:'2',cy:'2',r:'2.5',fill:pos.includes('b')?'rgba(251,191,36,0.5)':'rgba(165,42,58,0.5)'},
            React.createElement('animate',{attributeName:'r',values:'2;3.5;2',dur:'3s',repeatCount:'indefinite'}))));
    }),

    React.createElement('div',{className:'sbc__content'},
      React.createElement('div',{className:'sbc__label'+(phase>=2?' show':'')},
        String(slideNumber).padStart(2,'0')+' / '+String(totalSlides).padStart(2,'0')+' — POWER COIN'),

      // BCoin Hero — coin image + title
      React.createElement('div',{className:'sbc__hero'+(phase>=3?' show':'')},
        React.createElement('div',{className:'sbc__coin-wrap'},
          React.createElement('div',{className:'sbc__coin-glow'}),
          React.createElement('div',{className:'sbc__coin-orbit sbc__coin-orbit--1'}),
          React.createElement('div',{className:'sbc__coin-orbit sbc__coin-orbit--2'}),
          React.createElement('img',{src:'/bcoin.png',alt:'BCOIN',className:'sbc__coin-img',onError:function(e){e.target.style.display='none';}})),
        React.createElement('div',{className:'sbc__hero-text'},
          React.createElement('h1',{className:'sbc__title notranslate'},'BCOIN'),
          React.createElement('p',{className:'sbc__tagline notranslate'},'Decentralized Digital Currency'),
          React.createElement('p',{className:'sbc__sub'},'The native power token fueling the BNFT ecosystem — built on Binance Smart Chain with verified, transparent smart-contract architecture.'))),

      React.createElement('div',{className:'sbc__dv'+(phase>=4?' show':'')}),

      // Stats grid
      React.createElement('div',{className:'sbc__stats'+(phase>=5?' show':'')},
        STATS.map(function(s,i){
          var isActive=activeStat===i;
          return React.createElement('div',{key:i,className:'sbc__stat'+(isActive?' sbc__stat--active':''),style:{animationDelay:(i*80)+'ms'}},
            React.createElement('div',{className:'sbc__stat-lbl'},s.label),
            React.createElement('div',{className:'sbc__stat-val notranslate'},s.value));
        })
      ),

      // Contract address card
      React.createElement('div',{className:'sbc__contract'+(phase>=6?' show':'')},
        React.createElement('div',{className:'sbc__contract-row'},
          React.createElement('div',{className:'sbc__contract-col'},
            React.createElement('div',{className:'sbc__contract-lbl'},'CONTRACT ADDRESS'),
            React.createElement('div',{className:'sbc__contract-full notranslate',title:CONTRACT},CONTRACT),
            React.createElement('div',{className:'sbc__contract-short notranslate'},addrShort)),
          React.createElement('button',{className:'sbc__copy-btn'+(copied?' sbc__copy-btn--done':''),onClick:copyContract},
            copied?'✓ Copied':'⧉ Copy')),
        React.createElement('div',{className:'sbc__links'},
          React.createElement('a',{href:'https://bscscan.com/address/0xD38c8c437b7837Cf50F8E654D4880cf810ECDd22',target:'_blank',rel:'noopener noreferrer',className:'sbc__link'},
            React.createElement('span',{className:'sbc__link-icon'},'⌬'),' View on BscScan'),
          React.createElement('a',{href:'http://bcoin.one/',target:'_blank',rel:'noopener noreferrer',className:'sbc__link'},
            React.createElement('span',{className:'sbc__link-icon'},'🌐'),' bcoin.one'))),

      // Features
      React.createElement('div',{className:'sbc__features'+(phase>=6?' show':'')},
        FEATURES.map(function(f,i){
          return React.createElement('div',{key:i,className:'sbc__feature',style:{transitionDelay:((i+1)*100)+'ms'}},
            React.createElement('div',{className:'sbc__feature-icon'},f.icon),
            React.createElement('div',{className:'sbc__feature-body'},
              React.createElement('div',{className:'sbc__feature-lbl'},f.label),
              React.createElement('div',{className:'sbc__feature-sub'},f.sub)));
        })
      )
    ),
    React.createElement('div',{className:'sbc__bot'+(phase>=6?' show':'')},React.createElement('span',null,'bnft.live'))
  );
}
